/**
 * Prefill an authenticated admin CORRECTION of a saved DBS employer check.
 * Never infer a missing workforce/suitability decision from the job role.
 * Restore proof only when the tenant-owned compliance workflow has verified
 * that the linked source is currently accessible.
 */
const dateOnly = (value) => {
  if (typeof value !== 'string') return '';
  const match = /^(\d{4}-\d{2}-\d{2})/.exec(value);
  return match ? match[1] : '';
};

export function getDBSCheckEditPrefill(check, proofAvailable = false) {
  if (!check?.id) return null;
  const originalProofId = check.proof_document_id || check.evidence_document_id || null;
  const proofId = proofAvailable && originalProofId ? originalProofId : null;
  return {
    form: {
      method: check.method || '',
      checked_at: dateOnly(check.checked_at),
      outcome: check.outcome || 'follow_up_required',
      notes: check.notes || '',
      dbs_level: check.dbs_level || '',
      certificate_number: check.certificate_number || '',
      certificate_issue_date: dateOnly(check.certificate_issue_date),
      name_on_certificate: check.name_on_certificate || '',
      workforce: check.workforce || '',
      update_service_registered: check.update_service_registered === true,
      update_service_status: check.update_service_status || '',
      last_status_check_date: dateOnly(check.last_status_check_date),
      update_service_check_result: check.update_service_check_result || '',
      recheck_required: check.recheck_required !== false,
      next_recheck_date: dateOnly(check.next_recheck_date),
      review_due_at: dateOnly(check.review_due_at),
      result_status: check.result_status || '',
      information_present: check.information_present === true,
      result_summary: check.result_summary || '',
    },
    proofId,
    proofName: proofId ? 'Existing secured DBS proof — reused' : null,
  };
}
